import Itly, { FilterSelectedProperties } from 'itly';
import { FilterState, TrackableCLPFilter } from 'types/Category';

export function trackFilterSelected(
  attributeCode: string,
  optionSelected: string,
  filterState: FilterState
): void {
  const data: FilterSelectedProperties = {
    applied_filters: filterState?.filters as TrackableCLPFilter[],
    filter_option: attributeCode,
    filter_value: optionSelected
  };

  Itly.filterSelected(data);
}
